import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import './Sidebar.css';

const normalizePath = (path) => path.replace(/\/$/, '');

const isRouteMatch = (currentPath, routePath) => {
    const normalizedCurrent = normalizePath(currentPath);
    const normalizedRoute = normalizePath(routePath);

    if (normalizedRoute.includes(':id')) {
        const routePattern = normalizedRoute.replace(':id', '[^/]+');
        const regex = new RegExp(`^${routePattern}$`);
        return regex.test(normalizedCurrent);
    }

    return normalizedCurrent === normalizedRoute ||
        (normalizedRoute !== '' && normalizedCurrent.startsWith(normalizedRoute + '/'));
};

const SubSidebar = ({ activeSubMenu, subMenus }) => {
    const location = useLocation();

    if (!activeSubMenu || !subMenus[activeSubMenu]) return null;

    const subMenu = subMenus[activeSubMenu];

    const getResolvedPath = (path) => path;

    return (
        <div className="sub-sidebar">
            <div className="sub-sidebar-menu">
                {subMenu.items.map((item, index) => {
                    const resolvedPath = getResolvedPath(item.path);
                    const isActive = isRouteMatch(location.pathname, resolvedPath);
                    return (
                        <NavLink
                            key={index}
                            to={resolvedPath}
                            className={`sub-sidebar-link ${isActive ? 'active' : ''}`}
                        >
                            <span className="sub-sidebar-icon">
                                <i className={item.icon}></i>
                            </span>
                            <span className="sub-sidebar-title">{item.title}</span>
                        </NavLink>
                    );
                })}
            </div>
        </div>
    );
};

export default SubSidebar;
